import React from 'react';
import { Badge } from './Badge';
interface StatusPillProps {
  status: string;
  className?: string;
}
export const StatusPill: React.FC<StatusPillProps> = ({
  status,
  className
}) => {
  const normalizedStatus = status.toLowerCase();
  let variant: 'success' | 'warning' | 'error' | 'info' | 'neutral' = 'neutral';
  if (['active', 'approved', 'paid', 'completed', 'delivered', 'success', 'matched'].includes(normalizedStatus)) {
    variant = 'success';
  } else if (['pending', 'in progress', 'review', 'scheduled', 'draft', 'supplier-review', 'internal-review', 'negotiation', 'pending-signature', 'expiring-soon', 'under-review', 'payment-scheduled'].includes(normalizedStatus)) {
    variant = 'warning';
  } else if (['rejected', 'error', 'failed', 'overdue', 'blocked', 'critical', 'expired', 'terminated', 'exception'].includes(normalizedStatus)) {
    variant = 'error';
  } else if (['new', 'info', 'submitted', 'credit-note'].includes(normalizedStatus)) {
    variant = 'info';
  }
  return <Badge variant={variant} showDot className={className} data-id="element-227">
      {status}
    </Badge>;
};